exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".welcome-bg {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: #69AFAA;\n  background-image: url(\"/assets/bg/pattern-white-light.png\");\n  background-repeat: repeat;\n  background-position: 50% 50%; }\n\n.kl-frontpage-logo {\n  position: absolute;\n  width: 300px;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/components/welcome/welcome.component.scss
// module id = 192
// module chunks = 1